// These are the routes that are used in multiple components, routes that are only used
// once are in Container.tsx

import { UUIDPathRegex } from '@cbgms/base/utils/uuid'

const courtesyVehiclesBaseURL = '/courtesy-vehicles'
export const courtesyVehiclesURL = `${courtesyVehiclesBaseURL}/vehicles`
export const courtesyVehiclesBookingsURL = `${courtesyVehiclesBaseURL}/bookings`
export const courtesyVehiclesDetailsURL = `${courtesyVehiclesURL}/:vehicleUUID(${UUIDPathRegex})`
export const courtesyVehiclesAddURL = `${courtesyVehiclesURL}/add`
export const courtesyVehiclesDetailsURLTab = `${courtesyVehiclesDetailsURL}#replacementVehicle`

const rentalVehiclesBaseURL = '/rental-vehicles'
export const rentalVehiclesURL = `${rentalVehiclesBaseURL}/vehicles`
export const rentalVehiclesDetailsURL = `${rentalVehiclesURL}/:vehicleUUID(${UUIDPathRegex})`
export const rentalVehiclesAddURL = `${rentalVehiclesURL}/add`
export const rentalVehiclesDetailsURLTab = `${rentalVehiclesDetailsURL}#replacementVehicle`
export const rentalVehiclesContractsURL = `${rentalVehiclesBaseURL}/contracts`
export const rentalVehiclesAddContractURL = `${rentalVehiclesContractsURL}/new`
export const rentalVehiclesEditContractURL = `${rentalVehiclesContractsURL}/:workorderUUID(${UUIDPathRegex})/:lineUUID(${UUIDPathRegex})`
export const rentalVehiclesInvoicesURL = `${rentalVehiclesBaseURL}/invoices`
